export default [
  {
    name: 'ChannelsCompaniesList',
    path: 'settings/companies/channels',
    component: () => import('pages/settings/channels/ChannelsCompaniesList.vue')
  },
  {
    name: 'ChannelsList',
    path: 'settings/companies/:id/channels',
    component: () => import('pages/settings/channels/ChannelsList.vue')
  },
  {
    name: 'ChannelsCreate',
    path: 'settings/companies/:id/channels/new',
    component: () => import('pages/settings/channels/ChannelsForm.vue')
  },
  {
    name: 'ChannelsEdit',
    path: 'settings/companies/:id/channels/:channelId/edit',
    component: () => import('pages/settings/channels/ChannelsForm.vue')
  }
]
